<template>
  <ul ref="list" class="nav">
    <li
      class="nav-link-container"
      v-for="nav in navs"
      v-bind:item="nav"
      v-bind:key="nav.id"
    >
      <a class="nav-link" v-on:click="setactive($event)">
        <svg
          class="nav-svg"
          viewBox="0 0 40 12"
          preserveAspectRatio="xMidYMid meet"
        >
          <text
            x="20"
            y="9.5"
            text-anchor="middle"
            font-size="8"
            pointer-events="none"
          >
            {{ nav.text }}
          </text>
        </svg>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ButtonGroup',
  props: ['navs'],
  methods: {
    setactive: function(event) {
      let ul = event.target.closest('ul')
      // Go down 2 levels to select the SVG
      for (let li of ul.children) {
        li.children[0].children[0].classList.remove('active')
        li.childNodes[0].children[0].style.backgroundColor = 'transparent'
        li.children[0].style.borderColor = '#6D7278'
      }
      // Find the nav with the matching text
      event.target.classList.add('active')
      let targetNav = this.navs.find(
        el => el.text === event.target.textContent.trim()
      )
      event.target.style.backgroundColor = targetNav.color
      // Find the <a> hit by event (this element has the border)
      let borderItem = event.target.closest('a')
      // Set border to match fill
      borderItem.style.borderColor = targetNav.color
      this.$emit('selected-changed', targetNav.text)
    }
  },
  watch: {
    navs: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          // Set first nav wider (hacky)
          this.$refs.list.childNodes[0].classList.add('wide')
          this.$refs.list.childNodes[0].children[0].children[0].classList.add(
            'active'
          )
          this.$refs.list.childNodes[0].children[0].children[0].style.backgroundColor = this.navs[0].color
          this.$refs.list.childNodes[0].children[0].style.borderColor = this.navs[0].color
        })
      }
    }
  }
}
</script>

<style scoped>
.nav {
  margin: 0;
  padding: 0;
  display: flex;
  list-style: none;
}
.nav-link-container {
  flex: 1 1 10%;
}
.nav-link {
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  fill: #373737;
  border-color: #6d7278;
  border-width: thin;
  border-style: solid;
  text-decoration: none;
  background-color: transparent;
}
.nav-svg {
  display: block;
  height: 100%;
  width: 100%;
}
</style>
